import React, {useEffect} from 'react'

import Image from 'next/image'
import {motion, useAnimation} from 'framer-motion'

export const Benefits = () => {
  const controls = useAnimation()
  const BENEFITS = [
    {
      icon: 'accuracy',
      title: 'Accuracy of Data',
      description:
        'ระบุข้อมูลที่มีคุณภาพ ความถูกต้องและแม่นยำ<br/> เพื่อให้ Machine Learning ประมวลผลลัพธ์<br/>  มีประสิทธิภาพสูงสุด',
    },
    {
      icon: 'automation',
      title: 'Automation Capabilities',
      description:
        'ลดเวลาในการแปลงข้อมูลขั้นต้นให้อยู่ในรูปแบบ<br/> ที่ใช้งานได้ ช่วยเพิ่มประสิทธิภาพการวิเคราะห์<br/>และการเรียนรู้ของ Machine Learning',
    },
    {
      icon: 'workflows',
      title: 'Better Workflows',
      description:
        'สามารถจัดการข้อมูลจำนวนมากได้อย่างเป็น<br/>ระบบ การันตีความถูกต้องและความแม่นยำของ<br/>Machine Learning',
    },

    {
      icon: 'customizable',
      title: 'Customizable',
      description:
        'จำแนกข้อมูลได้อย่างอิสระตามโจทย์ของธุรกิจ<br/> และความต้องการที่แตกต่างกัน',
    },
    {
      icon: 'cost',
      title: 'Cost reduction',
      description:
        'ลดต้นทุนด้วยการจัดสรรทรัพยากร<br/> ที่เหมาะสม ลดการทำงานที่ซ้ำซ้อน<br/>ป้องกันข้อผิดพลาดที่อาจเกิดขึ้นซ้ำ',
    },
  ]

  useEffect(() => {
    const element = document.querySelector('.DataLabeling__benefits')
    const onScroll = () => {
      const elementTop = element.getBoundingClientRect().top
      const windowHeight = window.innerHeight

      if (elementTop < windowHeight * 0.75) {
        controls.start({opacity: 1, y: 0})
      } else {
        controls.start({opacity: 0, y: 50})
      }
    }

    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [controls])

  return (
    <motion.div
      className='DataLabeling__benefits'
      initial={{opacity: 0, y: 20}}
      animate={controls}
      transition={{duration: 0.1}}
    >
      <div className='DataLabeling__benefits__container'>
        <h2>
          เพิ่มศักยภาพ <span> AI ด้วยข้อมูลที่เหนือชั้น</span>
        </h2>
        <p>ด้วยบริการ Data Labeling ชั้นนำในประเทศไทย</p>
        <div className='DataLabeling__benefits__container__chart'>
          <div className='DataLabeling__benefits__container__chart__img'>
            <Image
              alt='Data Labeling'
              src='/images/services/data-labeling/chart.svg'
              width='402px'
              height='395px'
            />
          </div>

          <div className='DataLabeling__benefits__container__chart__content'>
            {BENEFITS.map((item, idx) => {
              return (
                <div key={idx} className='item'>
                  <img
                    src={`/images/services/data-labeling/${item.icon}-icon.svg`}
                  />
                  <h3>{item.title}</h3>
                  <div
                    className='description'
                    dangerouslySetInnerHTML={{__html: item.description}}
                  />
                </div>
              )
            })}
          </div>
        </div>
        <img
          src={`/images/services/data-labeling/benefits-bg.svg`}
          className='DataLabeling__benefits__container__bg'
          alt='data-labeling'
        />
        <img
          src={`/images/services/data-labeling/benefits-bg1.png`}
          className='DataLabeling__benefits__container__bg1'
          alt='data-labeling'
        />
        <img
          src={`/images/services/data-labeling/benefits-bg2.png`}
          className='DataLabeling__benefits__container__bg2'
          alt='data-labeling'
        />
      </div>
    </motion.div>
  )
}
